/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-not-found-page',
  templateUrl: 'not-found-page.component.html',
})
export class NotFoundPageComponent {
}
